import { Box, Heading, Image, Text } from "@chakra-ui/react";
import React from "react";
import privacy from "../../assets/privacy.png";
const PrivacyPolicy = () => {
  return (
    <Box w={"100%"} textAlign={"left"}>
      <Image src={privacy} w={"100%"} />
      <Box px={14} py={10}>
        <Heading color={"#3C375F"} mt={5}>
          Privacy Policy
        </Heading>
        <Text color={"#FF1C6B"} fontWeight={"bold"} fontSize={20} mt={4}>
          What does this policy cover
        </Text>
        <Text color={"#200E32"} fontSize={"14px"} mt={4} lineHeight={1.2}>
          Welcome to Wishfy! We value your privacy, and this Privacy Policy
          outlines how we collect, use, disclose, and protect your information
          when you use our online and mobile service. By using our Service, you
          agree to the terms of this policy. If you do not agree with this
          Privacy Policy, please refrain from using our Service. This policy
          applies to all users, including those accessing our Developer Portal.
        </Text>
        <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
          In summary, this policy explains how Wishfy collects and utilizes your
          information, and it provides you with options to control how we use
          your information.
        </Text>
        <Box mt={5}>
          <Text fontWeight={"bold"} fontSize={20}>
            1. Information we collect
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We collect various types of information about you, including:
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (a) Information you provide directly
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            When you register for a Wishfy account or communicate with us, we
            may ask for certain information such as your username, first and
            last names, birthdate, phone number, profession, physical and email
            address.
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Additionally, any messages you send us through the Service and any
            User Content you post (such as uploaded text and photos for your
            designs) may be collected by us. We utilize this information to
            operate and maintain the Service, provide you with its features and
            functionality, address your inquiries, and enhance your overall
            experience.
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Please note that failure to provide your personal information may
            limit your access to and use of our Service, potentially impacting
            your user experience.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (b) Information we receive from third-party applications
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            When you interact with the Service through third-party connections
            or log-ins, such as Facebook Connect, adding the Wishfy application,
            or linking your account, certain information about your use of those
            third-party services may be shared with Wishfy. This information may
            include your user ID (e.g., Facebook UID), access tokens required
            for service access, information you have permitted the third party
            to share, and any publicly available information associated with
            that service. Prior to connecting or linking third-party websites or
            services to our Service, it is advisable to review and adjust your
            privacy settings accordingly. You have the option to remove your
            third-party account from the Service by adjusting settings on the
            respective third-party service. In such cases, Wishfy will no longer
            receive information collected about you through that particular
            service. Additionally, if you integrate third-party applications
            into your designs or share content on social media platforms (e.g.,
            Instagram, Facebook, TikTok), we may receive user-generated content,
            such as videos, photos, account names, and comments related to
            Wishfy.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            When using the Service, information may be received from third-party
            applications, enhancing your experience and interactions with
            Wishfy.
          </Text>

          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (c) Information we receive from other third parties
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            To enhance our understanding of your profile and interests, we may
            obtain information about you from various third-party sources,
            including public sources, social media platforms (such as Facebook,
            Instagram, LinkedIn, Twitter), and third-party data providers. This
            information can include details like your company, company size, job
            title, seniority, industry, and other profile information. In some
            cases, we may share your email address or other information to
            acquire and combine data from these sources with the information you
            provide or that we collect when you use our Service.
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            The purpose of obtaining this information is to deliver personalized
            services and tailored offers to you. This can include relevant
            offers via email, chatbots, phone, or personalized advertising. If
            you prefer not to have Wishfy collect additional data about you from
            third-party providers for customization purposes, you have the
            option to opt out.
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Please note that some of these providers may combine data collected
            from our Service using technologies like cookies, pixels, tags,
            etc., with email or mailing addresses to provide us with insights
            that help us serve relevant offers to you.
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            If you are not a Wishfy subscriber, we may obtain your contact
            details from social media platforms (e.g., LinkedIn, Thru Friends &
            Family) or third-party data providers to promote our product
            offerings and subscriptions that we believe would be beneficial to
            you in your role.
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            It is possible that we have obtained your details from another
            Wishfy user, particularly if they have shared a design or greeting
            with you.
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Furthermore, we may receive information about your engagement with
            our advertisements from our ad servers, ad networks, and social
            media platforms. This information includes the websites you visited
            prior to accessing Wishfy, allowing us to assess advertising
            effectiveness and compensate our referral partners accordingly.
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            If you prefer to opt out of having your information used for these
            purposes, please contact us at{" "}
            <span style={{ color: "#1B8CEB" }}>support@wishfy.io.</span>
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We gather information from third-party sources to personalize our
            communications and promotions based on your interests. You can opt
            out at any time.
          </Text>

          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (d) Information we collect from you automatically
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            To help us analyze traffic and usage trends for the Service, we
            collect analytics data either directly or through third-party
            analytics tools. This data includes information sent by your browser
            or mobile device, such as the pages you visit and other relevant
            details (refer to the log file information section below) that
            assist us in enhancing the Service. For detailed information about
            the analytics cookies we use and how you can opt out of third-party
            data collection, please refer to our Cookies Policy.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We automatically collect certain information about your usage of our
            Service. To learn more about how we collect this information, please
            review our Cookies Policy.
          </Text>

          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (e) Cookies information and information taken from similar
            technologies
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            To enhance your experience on Wishfy, we utilize cookies - small
            text files that contain unique alphanumeric characters. These
            cookies enable functions such as faster logins, improved navigation,
            remembering your preferences, and overall enhancing the user
            experience. Additionally, cookies provide us with insights into how
            you use the Service, including the pages you view, the links you
            click, and other actions you take. They also help us measure traffic
            and usage trends, deliver personalized advertisements, assess their
            effectiveness, and identify potential new users.
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            You have the ability to manage or reset cookies and similar
            technologies through your web browser settings. This allows you to
            customize your cookie preferences, refuse all cookies, or receive
            notifications when a cookie is sent. However, please note that
            disabling cookies may affect certain features of the Service and
            limit its functionality. For detailed information on how we utilize
            cookies and similar technologies, as well as how you can control
            them, please refer to our Cookies Policy.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We utilize cookies for various purposes, including improving your
            Wishfy experience. To learn more about cookies and how you can
            manage them, please review our Cookies Policy.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (f) Log file information
          </Text>

          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            Each time you access the Service, your browser or mobile device
            automatically reports log file information. When using our Service,
            certain details are recorded in server logs. These logs include
            anonymous information such as your web request, browser type,
            referring/exit pages and URLs, number of clicks, interaction with
            links on the Service, domain names, landing pages, pages viewed, and
            other related information.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Your browser shares information with us about how you interact with
            Wishfy, and we store this information on our servers.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (g) Clear gifs/web beacons information
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            As part of our Service, we may utilize clear GIFs (web beacons) to
            anonymously track how users engage with our platform. These small,
            transparent images help us understand online usage patterns.
            Additionally, we may include clear GIFs in HTML-based emails to
            track email open rates and link clicks, enabling us to provide more
            accurate reporting and enhance the Service.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We use clear GIFs to analyze user behavior, including email
            engagement and website visits.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (h) Device identifiers
          </Text>

          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            When you access the Service on a device (including smartphones or
            tablets), we may access, collect, and monitor device identifiers,
            such as a universally unique identifier (UUID). These identifiers
            are small data files that uniquely identify your mobile device and
            provide us with information about how you use the Service. Device
            identifiers help improve your login and navigation experience, and
            certain features of the Service may not function properly if they
            are impaired. Wishfy utilizes device identifiers such as the Android
            Advertising ID and iOS Advertising Identifier.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Your device sends us information to enhance your experience.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (i) Location data
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            Wishfy collects location information for various purposes, including
            content personalization, compliance with local laws, analytics,
            advertising optimization, and tax estimation. We may collect your
            location data in the following ways:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            - When you provide, update, or confirm your location, such as during
            a purchase. <br /> - By inferring your location from your IP
            address. <br /> - Through our partners or your payment provider.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Wishfy utilizes your location data to enhance personalization,
            analytics, advertising, and tax-related activities.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (j) Content within your account
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            We receive content that you create within your Wishfy account and
            media you upload for use within it, such as designs, images,
            documents, videos, and metadata about your content.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Wishfy collects the content you upload to your account.
          </Text>

          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            2. How we use your information
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We use the information we collect about you for the purposes set out
            below:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            Providing you with the Service: We use the information that you
            directly give us to provide the Service to you. This includes
            allowing you to log in to Wishfy, operating and maintaining the
            Service, giving you access to your designs and billing you for
            transactions that you make via the Service. We also use information
            we collect about you automatically to remember information about you
            so that you will not have to re-enter it during your visit or the
            next time you visit the site.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            For data analytics:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We use information about you to help us improve the Wishfy Service
            and our users’ experience, including by monitoring aggregate metrics
            such as total number of visitors, traffic, and demographic patterns.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            For data and predictive analytics:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We may analyze content, media uploads and activity in your account
            (such as designs, photos, videos, audio, and search terms) to
            provide and customize the Service and to train our algorithms and
            models using machine learning in order to improve our Service. This
            is carried out with strict access controls and policies in place to
            protect your privacy. For certain machine learning projects, where
            legally required or we believe it is appropriate given the nature of
            project, we may seek your prior consent.
            <br /> These activities include, but are not limited to:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            labeling and detecting components in images (e.g., background, eyes)
            in order to enhance photo editing tools such as background removal,
            blemish and red eye correction and erasure of components;
            <br />
            labeling raw individual data (e.g., “man with dog”)
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            detecting content prohibited by our Acceptable Use Policy for
            moderation and security purposes (e.g., pornographic or copyright
            protected material); translating audio soundtracks;
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            predicting the most relevant subscription or product offerings for a
            user to tailor communications and advertising;
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            search terms and corresponding search results interaction data to
            build an algorithm to deliver the most relevant design result.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Customizing the Service for you:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We use and combine the information you provide us and information
            about you that we collect automatically and receive from other
            sources (including information we receive on and off our Service)
            and combine it with information about the behavior of other users to
            make sure that your use of the Service is customized to your needs.
            For example, to recommend templates, ingredients and fonts that are
            likely to be useful to you in a design, we may use information
            derived from your prior behavior on our Service, the use of these
            elements by other people working on similar designs and other
            inferred information.
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            To communicate with you about the Service: We use your contact
            information to get in touch with you and to send communications
            about critical elements of the Service. For example, we may send you
            emails about technical issues, security alerts or administrative
            matters.
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            To promote and drive engagement with the Wishfy Service: We use your
            contact information to get in touch with you about taking part in
            our surveys or about features and offers relating to the Service
            that we think you would be interested in. We also use information we
            collect about you to make sure that you get the most relevant offers
            and promotions based on your use of the Service, and your
            preferences. You can opt-out of these communications as described
            below.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            To improve the Service:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We analyze information about your use of the Service and your
            content to better understand how users are engaging with our Service
            and measure the effectiveness of the Service so we can make
            improvements and develop our services for users.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            For advertising purposes:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We use information about you, including cookies information and
            other information we (and our third-party partners) collect from you
            automatically about your use of the Service, to serve, personalize
            and measure the effectiveness of advertising on the Service and
            third-party sites and platforms. This includes showing you
            advertising we think you might find interesting as well as
            displaying advertising to potential new users that have similar
            interests.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Customer happiness:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We use information about you, information that we collect or and
            from within your account, information that you provide to our
            customer happiness team, and information about your interactions
            with the Service to resolve technical issues you experience with the
            Service, and to ensure that we can repair and improve the Service
            for all Wishfy users.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            For security measures:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We use information about you and from within your account to monitor
            activity that we think is suspicious or potentially fraudulent, and
            to identify violations of this Privacy Policy or our Terms of Use.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            For matters that you have specifically consented to:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            From time to time Wishfy may seek your consent to use your
            information for a particular purpose. Where you consent to our doing
            so, we will use it for that purpose. Where you no longer want us to
            use your information for that purpose you may withdraw your consent
            to this use.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            For troubleshooting, error resolution and service improvement:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We may need to review your designs to support your request for help,
            correct general errors with the Wishfy Service or improve our
            services.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            For matters that we are required to use your information by law:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Wishfy will use or disclose your information where we reasonably
            believe that such action is necessary to <br />
            (a) comply with the law and the reasonable requests of law
            enforcement; <br />
            (b) to enforce our Terms of Use and our Acceptable Use Policy or to
            protect the security or integrity of our Service; and/orbr <br />{" "}
            (c) to exercise or protect the rights, property, or personal safety
            of Wishfy, our users or others.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Summary:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Wishfy uses information about you for different reasons, including
            to provide, customize and improve the Service.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            3. Sharing your information
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (a) How we share your information
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            We share your information with third-party service providers for the
            purpose of providing the Service to you and to facilitate Wishfy’s
            legitimate interests. Those service providers will only be provided
            with access to your information as is reasonably necessary for the
            purpose that Wishfy has engaged the service provider, and we will
            require that such third parties comply with this Privacy Policy,
            appropriate data processing terms and any applicable laws.
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={3}>
            Some of the third parties with whom Wishfy may share your personal
            information are service providers who assist Wishfy with functions
            such as:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={2}>
            Billing; <br /> Customer support and customer management; <br />{" "}
            Email services; <br /> Hosting and storage; <br /> Data analytics
            and predictive analytics; <br />
            Data labelling and machine learning; <br /> Security; <br />
            Advertising and marketing services; <br />
            Domain name registration; <br /> Delivery of physical products;{" "}
            <br /> Other service providers.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We might share some information about you with our business partners
            and third-party service providers in order to provide the Service to
            you or to fulfill Wishfy’s legitimate business interests.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (b) How you can share your User Content
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            <b>(i) Public Posts</b>
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={3}>
            When you post information or content to the Service, such as public
            User Content, it becomes accessible to the public and may be read,
            collected, and used by others. Making your profile or User Content
            public means it can be globally available, searchable by other
            users, and indexed by search engines. Even if you or Wishfy remove
            the information, copies may still exist in cached or archived pages
            of the Service, or if other users have saved or copied that
            information.
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={2}>
            You have the option to share your Wishfy designs on various social
            media platforms, including LinkedIn, Facebook, Twitter, Pinterest,
            and Tumblr. It's important to review the privacy policies and
            settings of each platform and ensure you understand how your shared
            designs may be handled.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            When you post publicly on Wishfy, it can be seen by others globally
            and may be indexed by search engines. Remember to consider the
            privacy policies and settings of social media platforms when sharing
            your Wishfy designs
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            <b>(ii) Teams</b>
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={3}>
            When you are part of a Team on Wishfy, any information or content
            you create within the Team or any activities you engage in with the
            Team may be shared with other Team members and the Team Owner. If
            requested by the Team Owner, Wishfy has the authority to reassign
            ownership of the User Content you post in the Team to either the
            Team Owner or another Team member. To maintain the privacy of
            personal or confidential information, it is advisable to keep such
            content separate in a personal account.
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            <b>(iii) Design Collaboration</b>
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={3}>
            If you accept an invitation to view or edit a Wishfy design:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={3}>
            - Your name and avatar will be visible to all participants in the
            design, regardless of their logged-in status or anonymity. <br />-
            Your name and login time will be accessible to any other individuals
            who have edit access to the same design, regardless of whether they
            are within your Team or not.
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            If you prefer to maintain anonymity in these scenarios, you can
            easily opt out of insights collection by clicking here and selecting
            "Opt out of insights collection" under the Insights section.
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            As the owner or editor of an individual design, you have the
            flexibility to control access by utilizing the following link
            sharing settings:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            <b>1. "Only people added can access":</b> Only individuals who have
            been added to the design through their email or Wishfy account will
            have access. Others who haven't been added will need to request
            access from you. This is the default and most private sharing option
            for all designs on Wishfy.
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            <b>2. "Anyone with the link":</b> Anyone with the link can access
            your design and, if selected, view or edit it. However, we do not
            recommend this option for confidential information. Please note that
            by default (except for Wishfy for Education subscriptions), this
            setting allows non-Wishfy users to anonymously access your design
            and view the full names, avatars, cursors, and comments of logged-in
            users.
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            <b>3. "Only your team*":</b> Only Team members with the link can
            access, view, or edit your design, as per your selection. This means
            that if you share the link via email or Slack communication with
            multiple individuals in your Team, any of them can access the design
            without requiring additional permission. *Subject to availability
            for your team.
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={4}>
            Wishfy collects and retains the links you share, and they may be
            shared with service providers as necessary to provide the Services.
            Once you share a link, it is possible for your recipients to further
            share it.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            By default, designs on Wishfy are private. When sharing designs, it
            is essential to review and select appropriate privacy settings. For
            designs containing personal or confidential information, it is not
            recommended to use the "anyone with the link" setting.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (c) Sharing in connection with a merger, acquisition, or
            reorganization
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={3}>
            In the event of a merger, acquisition, reorganization, financing,
            sale of assets, bankruptcy, or insolvency involving Wishfy or any
            portion of our assets, services, or businesses, Wishfy may share,
            sell, or transfer your information to third parties. This may
            include customer names, email addresses, User Content, and other
            user-related information. If such a transaction occurs, we will
            notify you via email and/or a notice on the Service, and inform you
            of any material changes in the way we handle your data under this
            policy.
          </Text>
          <Text mt={3} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            If we sell our business, your information may be part of the sale.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (d) Your employer
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={3}>
            If you access Wishfy using an email address provided by your
            employer (business, non-profit, or educational institution), and
            your employer has an account with Wishfy or is considering creating
            one, you acknowledge that Wishfy may share your name, email, and the
            existence of your Wishfy account with your employer. If you do not
            wish for this information to be shared, you can opt out at any time
            by emailing us at{" "}
            <span style={{ color: "#1B8CEB" }}>privacy@Wishfy.com</span>
          </Text>
          <Text mt={3} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We may share limited information with your employer.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (e) Sharing with other third parties
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={3}>
            Wishfy may share your information with third parties in specific
            circumstances, such as when you consent to sharing for a particular
            purpose.
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={2}>
            You or your account administrator may choose to work with
            third-party applications listed on our platform to enhance your
            designs or streamline your workflow. These applications, such as
            YouTube, Google Drive, LinkedIn, or Slack, may involve importing or
            exporting data between Wishfy and the third-party application. When
            connecting your Wishfy account to a third-party application, you
            will be asked for permission. It's important to note that these
            third-party apps are not under our control, and their use of your
            information is not covered by this privacy policy. We recommend
            reviewing the terms and conditions of any third-party apps before
            connecting them to the Service. If you object to sharing your
            information with these third parties, refrain from installing the
            app.
          </Text>
          <Text mt={3} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We may share your data with third-party applications if you choose
            to integrate them with Wishfy, but we do not control how these apps
            use your information.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (f) Sharing aggregate data
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={3}>
            We may aggregate or strip personally identifying characteristics
            from data and share that anonymized data with third parties.
          </Text>
          <Text mt={3} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We may share anonymized data with third parties.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (g) Sharing with authorities
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2} mt={3}>
            We may access, preserve, and share your information with regulators,
            law enforcement, and other authorities as necessary to detect,
            prevent, or address fraud, breaches of our Terms of Use or
            Acceptable Use Policy, harmful or illegal activity, or to protect
            Wishfy, yourself, or others. This includes investigations,
            regulatory inquiries, and situations where there is a threat of
            death or imminent bodily harm.
          </Text>
          <Text mt={3} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We may share data with authorities when required or necessary.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            4. Advertising
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We work with third-party ad servers, ad networks, and social media
            platforms (such as Facebook, Google, LiveRamp, Outbrain, Taboola,
            and Appsflyer) to deliver personalized ads on our Service and other
            websites. This is done to show you ads that may be of interest to
            you, measure their effectiveness, and identify potential new users
            of our Service.
          </Text>
          <Text mt={3} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We may share certain information with our third-party advertising
            partners, including your email address, location, cookie
            information, and data related to your use of our Service. Our
            partners may also match your information with data from other
            networks or sites to serve ads on our Service or third-party
            websites. We may also share information with social media platforms
            like Facebook and TikTok to display ads to potential new users who
            share similar demographics and behavior with our existing users. If
            you wish to opt out of having your email matched by LiveRamp, you
            can do so here or by emailing{" "}
            <span style={{ color: "#1B8CEB" }}>privacy@Wishfy.com</span>
          </Text>
          <Text mt={3} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We work with third parties to deliver personalized ads and measure
            their effectiveness. We may share certain information for this
            purpose, but you can opt out of email matching by contacting us.
          </Text>
          <Text mt={5} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            In addition, these third-party ad servers or ad networks may use
            technology to send, directly to your browser or mobile device, these
            personalized ads and ad links directly to your browser or mobile
            device, and will automatically receive your IP address when they do
            so. They may also use other technologies (such as cookies,
            JavaScript, device identifiers, location data, and clear gifs) to
            compile information about your browser’s or device’s visits and
            usage patterns on the Service, and to measure the effectiveness of
            their ads and to personalize the advertising content. Please see our
            Cookies Policy for more information about how we and our third party
            partners use cookies and other technologies to deliver ads to you.
          </Text>
          <Text mt={3} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Wishfy does not sell or rent the information we collect directly
            from you or about you from third parties with these third-party ad
            servers or ad networks for such parties’ own marketing purposes.
          </Text>
          <Text mt={3} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Please note that an advertiser may ask Wishfy to show an ad on the
            Service to a certain audience of users (e.g., based on demographics
            or other interests). In that situation, Wishfy determines the target
            audience and Wishfy serves the advertising to that audience and only
            provides anonymous aggregated data to the advertiser. If you respond
            to such an ad, the advertiser or ad server may conclude that you fit
            the description of the audience they are trying to reach.
          </Text>
          <Text mt={3} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            The Wishfy Privacy Policy does not apply to, and we cannot control
            the activities of, third-party advertisers. Please consult the
            respective privacy policies of such advertisers or contact such
            advertisers for more information.
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            <b>Wishfy for Education:</b>
            <br />
            - Please note that this Section 4 does not apply to students using
            Wishfy for Education <br /> - we do not serve advertising to
            students using Wishfy for Education.
          </Text>
          <Text mt={3} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Summary:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            If we have ads on our site we might use some of your info to show
            you appropriate ads. We may also use some of that info to send you
            relevant ads on other sites, like Facebook or Google.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            5. How we transfer, store and protect your data
          </Text>
          <Text mt={2} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Your information collected through the Service will be stored and
            processed in the United States, Australia, Singapore, European
            Union, United Kingdom, Philippines and New Zealand and any other
            country in which Wishfy or its subsidiaries, affiliates or service
            providers maintain facilities or employ staff or contractors. Wishfy
            transfers information that we collect about you, including personal
            information, to affiliated entities, and to other third parties
            across borders and from your country or jurisdiction to other
            countries or jurisdictions around the world. As a result, we may
            transfer information, including personal information, to a country
            and jurisdiction that does not have the same data protection laws as
            your jurisdiction. However, we always take steps to ensure that your
            information remains protected wherever it is stored and processed in
            accordance with applicable laws. Where required under applicable
            laws, you consent to the transfer of information to the U.S. or any
            other country in which Wishfy or its parent, subsidiaries,
            affiliates or service providers maintain facilities and the use and
            disclosure of information about you as described in this Privacy
            Policy.
          </Text>
          <Text mt={3} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            To run our Service, we’ll have to use our Wishfy group members and
            vendors around the world. This means your information might be
            transferred to the U.S., Indonessia, Europe, Singapore, Philippines,
            New Zealand and anywhere else the Service is operated.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            6. Keeping your information safe
          </Text>
          <Text mt={2} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Wishfy cares about the security of your information, and uses
            appropriate safeguards to preserve the integrity and security of all
            information collected through the Service. To protect your privacy
            and security, we take reasonable steps (such as requesting a unique
            password) to verify your identity before granting you access to your
            account. You are responsible for maintaining the secrecy of your
            unique password and account information, and for controlling access
            to your email communications from Wishfy, at all times. However,
            Wishfy cannot ensure or warrant the security of any information you
            transmit to Wishfy or guarantee that information on the Service may
            not be accessed, disclosed, altered, or destroyed. Your privacy
            settings may also be affected by changes to the functionality of
            third party sites and services that you add to the Wishfy Service,
            such as social networks. Wishfy is not responsible for the
            functionality or security measures of any third party.
          </Text>
          <Text mt={3} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            For more information about Wishfy security, please visit Security at
            Wishfy.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Summary:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We care about the safety of your data and have implemented industry
            recognized measures to protect it, but unfortunately we can’t
            guarantee that nothing bad will ever happen to it.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            7. Your choices about your information
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (a) You control your account information and settings
          </Text>
          <Text mt={3} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We provide choices about how we process your account information:
          </Text>
          <Text mt={3} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            You can correct, download or delete the data in your account in Your
            Account settings; <br />
            You can request access, correction or deletion of the data Wishfy
            holds on you by contacting{" "}
            <span style={{ color: "#1B8CEB" }}>
              privacy@Wishfy.com
            </span> <br /> and You can opt out of receiving marketing messages
            in the “Message Preferences” section of Your Account settings here
            or by clicking on the “unsubscribe link” provided in such
            communications. However, you may not opt out of Service-related
            communications (e.g., account verification, purchase and billing
            confirmations and reminders, changes/updates to features of the
            Service, technical and security notices). Summary: You have control
            over your account settings, such as your account information and
            marketing email notifications, but there’s some important stuff
            we’ll always send you. If you have any questions about reviewing or
            modifying your account information, you can contact us directly at
            support@Wishfy.io.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (b) Opting out of collection of your information through tracking
            technologies
          </Text>
          <Text mt={3} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Please refer to your mobile device or browser’s technical
            information for instructions on how to delete and disable cookies,
            and other tracking/recording tools. Depending on your type of
            device, it may not be possible to delete or disable tracking
            mechanisms on your mobile device. Note that disabling cookies and/or
            other tracking tools prevents Wishfy or its business partners from
            tracking your browser’s activities in relation to the Service, and
            for use in targeted advertising activities by Wishfy, including via
            third-party websites. However, doing so may disable many of the
            features available through the Service. If you have any questions
            about opting out of the collection of cookies and other
            tracking/recording tools, please read our Cookies Policy or you can
            contact us directly at{" "}
            <span style={{ color: "#1B8CEB" }}>privacy@Wishfy.com</span>
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Summary:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            If you want us to stop collecting information about you, there may
            be some settings you can adjust in your browser or device. But
            Wishfy might not be personalized for you without it, making it
            harder to find what you're looking for.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (c) Opting out of enrichment using third-party data
          </Text>
          <Text mt={3} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            As described above, we may combine information about you with
            information obtained from third-party sources to better understand
            your profile and interests so that we can deliver customized offers
            and other personalized services. You can opt out of Wishfy
            collecting more data about you from third-party providers to tailor
            your experience and messages we send you here or by emailing
            support@Wishfy.io.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Summary:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            You can opt out of receiving Wishfy promotions based on information
            we learn about you from third parties, for example, your job title
            and employer.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            (d) Rights in respect of your Information
          </Text>
          <Text mt={3} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            The laws of some countries grant particular rights in respect of
            personal information. Individuals in certain countries, including
            the European Union, United Kingdom, and Brazil have the right to:
          </Text>
          <Text mt={2} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Request access to their information; <br />
            Request that we correct inaccuracies in their information; <br />
            Request that their information be deleted or that we restrict access
            to it; <br />
            Request a structured electronic version of their information and
            Object to our use of their information. <br />
            <Text mt={1} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
              Should you wish to make a request in respect of your personal
              information please contact us at support@Wishfy.io. You also have
              the right to object to our processing of personal data about you
              in for marketing purposes and we will stop processing data for
              that purpose.
            </Text>
          </Text>
          <Text mt={4} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            In some circumstances Wishfy will not be able to comply with your
            request regarding your personal data. If we are unable to remove any
            of your information, we will explain why. For example, we may not be
            able to provide a copy of your information where it infringes on the
            rights of another user. In some cases, you may have shared your
            information with third parties, such as by publishing a design on a
            third party’s website. In that case Wishfy will not be able to
            delete the information, and you will need to contact that third
            party directly.
          </Text>
          <Text mt={3} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            If we are unable to resolve your request, or if you are concerned
            about a potential violation, you also have the option to report the
            issue or make a complaint to the data protection authority in your
            jurisdiction. Where you have provided your consent to certain
            processing and no longer want us to use your information for that
            purpose, you may withdraw your consent to this use, although this
            will not affect the lawfulness of processing based on consent before
            its withdrawal. Please see paragraph “You control your account
            information and settings” for more options on how to opt-out of
            marketing communications.
          </Text>
          <Text mt={3} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Summary: You may have specific rights in relation to your
            information depending on where you live. Wishfy provides you with a
            number of controls in Your Account settings and you can access your
            privacy rights by emailing support@Wishfy.io.
          </Text>
          <Text fontWeight={"bold"} fontSize={20} mt={4}>
            8. How long we keep your information
          </Text>
          <Text mt={2} color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            Following termination or deactivation of your user account, Wishfy
            will retain your profile information and User Content for a
            commercially reasonable time, and for as long as we have a valid
            purpose to do so. In particular, Wishfy will retain your information
            for the purpose of complying with its legal and audit obligations,
            and for backup and archival purposes.
          </Text>
          <Text mt={4} color={"#8172D5"} fontSize={"14px"} lineHeight={1.2}>
            Long story short:
          </Text>
          <Text color={"#200E32"} fontSize={"14px"} lineHeight={1.2}>
            We retain your profile information and user content for the purpose
            of providing our Service to you and to comply with our legal and
            regulatory obligations.
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default PrivacyPolicy;
